import { useNavigate } from 'react-router-dom';

const Content = ({ children }: any) => {
    const navigate = useNavigate();

    return (
      <div className='relative w-full flex flex-col overflow-x-hidden bg-white'>
        {children}
      </div>
    );
};

export default Content;